import React, { useCallback } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { theme } from '@garnish/constants';
import { Container } from '@sg/garnish';

import { useIsLoggedIn } from '@order/AuthMachine';
import {
  AccountScreenTitle,
  NotFoundView,
  RedeemGiftCardForm,
  SignedOutView,
  TransparentModal,
} from '@order/components';
import { useCustomerCredit } from '@order/hooks';
import { useFeatureFlag } from '@order/LaunchDarkly';
import { useLocalizationContext } from '@order/Localization';

// ─────────────────────────────────────────────────────────────────────────────

export const AddGiftCardScreen = () => {
  const { t } = useLocalizationContext();
  const navigation = useNavigation();

  const isLoggedIn = useIsLoggedIn();
  const shouldSeparatePromoAndGiftCard = useFeatureFlag(
    'CELS-1410-separate-promo-and-gift-card',
  );
  const { refetchCredits } = useCustomerCredit({
    requestPolicy: 'cache-and-network',
  });

  // ─── Helpers ─────────────────────────────────────────────────────────

  const onRedeemSuccess = useCallback(() => {
    refetchCredits();
    navigation.goBack();
  }, [navigation, refetchCredits]);

  // ─────────────────────────────────────────────────────────────────────

  if (!shouldSeparatePromoAndGiftCard) return <NotFoundView withoutFooter />;

  if (!isLoggedIn)
    return <SignedOutView redirectTo="add-gift-card" withoutFooter />;

  return (
    <TransparentModal size="full" onClose={navigation.goBack} disableAnimation>
      <ScrollView scrollEnabled={false}>
        <Container wrapperStyle={styles.container} style={styles.container}>
          <AccountScreenTitle title={t('add-gift-card.title')} />

          <View style={styles.formContainer}>
            <RedeemGiftCardForm onRedeemSuccess={onRedeemSuccess} />
          </View>
        </Container>
      </ScrollView>
    </TransparentModal>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.OATMEAL,
  },
  formContainer: {
    paddingTop: theme.spacing['8'],
  },
});
